import { GetImageStore } from "SessionState/Image/ImageStore";
import CsLineIcons from "cs-line-icons/CsLineIcons";
import { useFormikContext } from "formik";
import { useState, useRef, useEffect } from "react";
import { Button, Form, Spinner } from "react-bootstrap";
import ImageRender from "./ImageRender";

export interface IImage {
    image: {
        id: number;
        image: string;
        imageName: string;
        imageType: string;
    }
  }

interface ImageUploadProps {
    image: string | undefined;
    className?: string; // Make className optional
    containerName?: string;
}

const ImageUpload: React.FC<ImageUploadProps> = ({ image, containerName = 'default-container', className: customClassName  }) => {
    const refFileUpload = useRef<HTMLInputElement>(null);
    const [imageUrl, setImageUrl] = useState<string | undefined>(image || '/img/profile/imagePlaceholder_1.png');
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const imageStore = GetImageStore();
    const defaultClassName = 'rounded-xl border border-separator-light border-4 sw-20 sh-20 h-auto'; // Default className

    const className = customClassName ? `${customClassName}` : defaultClassName;

    // const { handleChange } = useFormikContext<{ image: { id: number; image: string; imageName: string; imageType: string } }>();
    const { handleChange } = useFormikContext<{ image: { id: number; image: string; imageName: string; imageType: string; containerName: string } }>();


    const onThumbChangeClick = () => {
        if (refFileUpload.current) {
            refFileUpload.current.click();
        }
    };

    const changeThumb = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = (loadEvent) => {
                const result = loadEvent.target?.result as string;
                setImageUrl(result);
            };
            reader.readAsDataURL(file);
        }
    };

    const handleFileUpload = async (file: File) => {
        setIsLoading(true);
        try {
            console.log("Container Name:", containerName);
            const res = await imageStore.uploadImage({ FileName: file.name, File: file }, containerName);
            setImageUrl(res);
            const image = { id: 0, image: res, imageName: file.name, imageType: file.type };
            handleChange({ target: { name: 'image', value: image } });
        } catch (error) {
            console.error("Error uploading image:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (file) {
            changeThumb(event);
            handleFileUpload(file);
        }
    };

    const handleRemoveImage = () => {
        setImageUrl('/img/profile/imagePlaceholder_1.png'); // Set the default placeholder for display
        handleChange({ target: { name: 'image', value: { id: 0, image: '', imageName: '', imageType: '', containerName: '' } } }); // Set the image to an empty object with default values
    };
    


    useEffect(() => {
        if (image) {
            setImageUrl(image);
        }
    }, [image]);

    return (
        <div className="mb-3 mx-auto position-relative" id="imageUpload">
                 {isLoading && (
                <div className="d-flex justify-content-center">
                    <Spinner animation="grow" variant="primary" />
                </div>
            )}
            <ImageRender src={imageUrl || undefined} alt='Image Upload'  containerName={containerName}    className={`${className} ${isLoading ? 'd-none' : 'd-block'}`} />
            <Button
                size="sm"
                variant="separator-light"
                className="btn-icon btn-icon-only position-absolute rounded-xl s-0 b-0"
                onClick={onThumbChangeClick}
            >
                <CsLineIcons icon="upload" className="text-alternate" />
            </Button>
            {imageUrl && imageUrl !== '/img/profile/imagePlaceholder_1.png' && (
                <Button
                    size="sm"
                    variant="danger"
                    className="btn-icon btn-icon-only position-absolute top-0 m-1 "
                    onClick={handleRemoveImage}
                >
                  <CsLineIcons icon="bin" className="text-white" />
                </Button>
            )}
            <Form.Control
                type="file"
                ref={refFileUpload}
                className="file-upload d-none"
                accept="image/*"
                onChange={handleInputChange}
            />
            {isLoading && <Spinner animation="border" variant="primary" />}
        </div>
    );
};

export default ImageUpload;
